import React from "react"

import { MobileChannelWrapper } from "../styled"
import { Box } from "reflexbox"
import { Link } from "gatsby"

import channelArrow from "../../images/channelArrow.png"

const MobileChannel = (props) => {
  const channelPath = props.channel.name === "Home" ? "/" : props.channel.path

  const handleClick = () => {
    props.outerClick()
    props.channelClick()
  }

  return (
    <MobileChannelWrapper>
      <Box>
        <Link to={channelPath} onClick={handleClick}>
          <h2>{props.channel.name}</h2>
        </Link>
      </Box>
      <Box className="mobile-channel-arrow">
        <Link to={channelPath} onClick={props.outerClick}>
          <img src={channelArrow} alt="click to go to channel" />
        </Link>
      </Box>
    </MobileChannelWrapper>
  )
}

export default MobileChannel
